import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useMemo } from 'react';
import { extractCommonItemProps } from '../../../../../../../util/layout/layoutPropsExtractor.js';
import '../../../../../../../util/styles/index.js';
import { useId } from '@react-aria/utils';
import { useAdsStyles } from '../../../../../../../util/styles/hooks/useAdsStyles.js';

var _excluded = ["id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useRoot = function useRoot(props) {
  // ===DO=== the cleanup props here
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var id = props.id,
    rest = _objectWithoutProperties(props, _excluded);
  // generate unique id for control
  var uId = useId(id); // can add ADS signature here

  var fieldIds = useMemo(function () {
    return {
      id: uId,
      helperTextId: "".concat(uId, "-helper"),
      labelId: "".concat(uId, "-label"),
      validationMessageId: "".concat(uId, "-validation-message"),
      counterId: "".concat(uId, "-char-counter")
    };
  }, [uId]);
  var commonItemProps = extractCommonItemProps(props);
  var formFieldContainerStyles = mapAdsStyles(_objectSpread({
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  }, commonItemProps));
  return _objectSpread(_objectSpread(_objectSpread({}, fieldIds), rest), {}, {
    formFieldContainerStyles: formFieldContainerStyles
  });
};

export { useRoot };
//# sourceMappingURL=useRoot.js.map
